import { Controller } from '@hotwired/stimulus';

/**
 * Toast type mdcs : déplacement vers #toast-container, barre de progression, auto-fermeture.
 */
export default class extends Controller {
    static targets = ['progressBar'];

    static values = {
        delay: { type: Number, default: 5000 },
    };

    connect() {
        this.timeoutId = null;
        this.intervalId = null;
        this.progress = 0;
        this.moveToContainer();

        requestAnimationFrame(() => {
            this.element.classList.add('toast--is-visible');
        });

        this.timeoutId = setTimeout(() => this.hide(), this.delayValue);
        this.handleProgressBar();

        this.boundPause = this.pauseProgress.bind(this);
        this.boundResume = this.resumeProgress.bind(this);
        this.element.addEventListener('mouseenter', this.boundPause);
        this.element.addEventListener('mouseleave', this.boundResume);
    }

    disconnect() {
        this.clearTimers();
        this.element.removeEventListener('mouseenter', this.boundPause);
        this.element.removeEventListener('mouseleave', this.boundResume);
    }

    moveToContainer() {
        const container = document.getElementById('toast-container');
        if (container && this.element.parentNode !== container) {
            container.appendChild(this.element);
        }
    }

    hide() {
        if (!this.element.isConnected || this.element.dataset.toastClosing === '1') {
            return;
        }
        this.element.dataset.toastClosing = '1';

        this.clearTimers();
        this.element.classList.remove('toast--is-visible');
        this.element.classList.add('toast--is-hiding');

        setTimeout(() => {
            if (this.element.isConnected) {
                this.element.remove();
            }
        }, 1000);
    }

    clearTimers() {
        clearTimeout(this.timeoutId);
        clearInterval(this.intervalId);
        this.timeoutId = null;
        this.intervalId = null;
    }

    handleProgressBar() {
        if (!this.hasProgressBarTarget) {
            return;
        }

        const step = Math.max(1, Math.floor(this.delayValue / 100));

        this.intervalId = setInterval(() => {
            this.progress += 1;
            this.progressBarTarget.style.width = `${this.progress}%`;

            if (this.progress >= 100) {
                clearInterval(this.intervalId);
                this.intervalId = null;
                this.hide();
            }
        }, step);
    }

    pauseProgress() {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
        clearInterval(this.intervalId);
        this.intervalId = null;
    }

    resumeProgress() {
        const remainingTime = ((100 - this.progress) / 100) * this.delayValue;
        this.timeoutId = setTimeout(() => this.hide(), remainingTime);
        this.handleProgressBar();
    }
}
